import { authHeader } from '@/_helpers';
export const lenguagesService = {
    getAll,
};

const apiUrl = process.env.VUE_APP_ROOT_API;

function getAll() {

    let languages = [
        {
            "id": "1",
            "name": "French",
            "lang_code": "fr",
            "active": "1"
        },
        {
            "id": "2",
            "name": "English",
            "lang_code": "en",
            "active": "1"
        },
        {
            "id": "3",
            "name": "Spanish",
            "lang_code": "es",
            "active": "1"
        }
    ];
    
      // Devuelve una promesa que resuelve con el array simulado
      return new Promise((resolve, reject) => {
        resolve(languages);
      });


}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            const error = data || response.statusText;
            return Promise.reject(error);
        }
        return data;
    });
}